import { MATCH_BANDS } from "@/lib/mastering";

export const fmtDb = (v) => (v == null || !isFinite(v) ? "—" : v.toFixed(1));

export const Meter = ({ label, value, unit, testid, tone = "text-white", hint }) => (
  <div className="rounded-xl border border-white/10 bg-[#0b1d3a] p-4" data-testid={testid} title={hint}>
    <p className="font-mono-tga text-[10px] uppercase tracking-[0.2em] text-sky-300/80">{label}</p>
    <p className={`font-display text-2xl font-black mt-1 ${tone}`}>{value} <span className="text-xs text-zinc-400">{unit}</span></p>
  </div>
);

export const StatsRow = ({ a, prefix, master }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-testid={`${prefix}-stats`}>
    <Meter label={master ? "Loudness master" : "Loudness originale"} value={fmtDb(a?.lufs)} unit="LUFS" testid={`${prefix}-lufs`} tone={master ? "text-emerald-300" : "text-white"} hint="Volume percepito integrato (ITU-R BS.1770)" />
    <Meter label="True peak" value={fmtDb(a?.truePeak)} unit="dBTP" testid={`${prefix}-tp`} tone="text-amber-400" hint="Picco reale tra i campioni (4x)" />
    <Meter label="Short-term max" value={fmtDb(a?.stMax)} unit="LUFS" testid={`${prefix}-st`} hint="Volume massimo su 3 secondi" />
    <Meter label="Dinamica (LRA)" value={fmtDb(a?.lra)} unit="LU" testid={`${prefix}-lra`} hint="Loudness Range" />
    <Meter label="PLR" value={fmtDb(a?.plr)} unit="dB" testid={`${prefix}-plr`} hint="Rapporto picco/loudness: più alto = più punch" />
  </div>
);

const label = (f) => (f >= 1000 ? `${f / 1000}k` : `${f}`);
export const Spectrum = ({ before, after }) => {
  const h = (v) => `${Math.max(4, Math.min(100, 50 + (v || 0) * 3))}%`;
  return (
    <div className="rounded-xl border border-white/10 bg-[#0b1d3a] p-4" data-testid="mastering-spectrum">
      <div className="flex flex-wrap gap-x-4 gap-y-1 justify-between font-mono-tga text-[10px] uppercase tracking-[0.2em] text-sky-300/80 mb-3">
        <span>Analizzatore di spettro (bande d'ottava)</span>
        <span className="whitespace-nowrap"><span className="text-zinc-300">■ originale</span>{after && <span className="text-emerald-300 ml-3">■ master</span>}</span>
      </div>
      <div className="flex items-end gap-2 h-32">
        {MATCH_BANDS.map((f, i) => (
          <div key={f} className="flex-1 flex flex-col items-center gap-1 h-full">
            <div className="flex-1 w-full flex items-end gap-0.5">
              <div className="flex-1 rounded-t bg-zinc-400/50 transition-[height] duration-500" style={{ height: h(before?.[i]) }} />
              {after && <div className="flex-1 rounded-t bg-emerald-400 transition-[height] duration-500" style={{ height: h(after[i]) }} />}
            </div>
            <span className="font-mono-tga text-[9px] text-zinc-400">{label(f)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
